import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

import {FrontConfig} from '../../bundler/bundlerDefineConfig';

export function buildBugsnagOptions() {
  return {
    apiKey: '9e0d190bd69662be37bc0659aca27a1a',
    appVersion: FrontConfig.GIT_COMMIT,
    releaseStage: FrontConfig.FRONT_ENV,

    autoTrackSessions: false,
    redactedKeys: [/^(authorization|x-front-xsrf|password)$/i],
    plugins: [new BugsnagPluginReact(React)],
  };
}
